import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { InfinitySelect, type InfinitySelectOption } from "~components/InfinitySelect";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { LeaderCriteriaResponse } from "~types/leaderCriteria.ts";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties";

type Props = SelectBaseSingleProperties<InfinitySelectOption>;

export const SelectLeaderCriteria = ({ value, ...props }: Props) => {
  const { sport, organizationId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: LeaderCriteriaResponse) =>
    (response?.data || []).map((x) => ({ label: x.name, value: x.leaderCriteriaId }));

  return (
    <InfinitySelect<LeaderCriteriaResponse>
      {...props}
      url={`${sport}/o/${organizationId}/statistics/leaders/criteria`}
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.LEADER_CRITERIA_SET}
      permissionOperation={PermissionOperations.READ}
    />
  );
};
